import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=bef3d064&scoped=true"
import script from "./AttachmentInput.vue?vue&type=script&lang=js"
export * from "./AttachmentInput.vue?vue&type=script&lang=js"
import style0 from "./AttachmentInput.vue?vue&type=style&index=0&id=bef3d064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef3d064",
  null
  
)

export default component.exports